const state = {
	currentSlide: 1,
	currentType: {},
	mainFilter: {}
}

const getters = {
	getSideMenuField: (state) => (filterName) => {
		return state[filterName];
	}
}

const actions = {
	changeSideMenuField({commit}, {fieldName, payload}) {
		commit('updateSideMenuField', {fieldName, payload})
	}
}

const mutations = {
	updateSideMenuField(state, {fieldName, payload}) {
		state[fieldName] = payload;
	}
}

export default {state, getters, actions, mutations};
